import { CurrencyDto } from "services/constantsRegistry/restModels";

// Фолбэк на случай, если валюта ещё не пришла из констант: формы не должны падать,
// а два знака после запятой — поведение всех поддерживаемых валют.
const FALLBACK_DECIMAL_PLACES = 2;

export interface CurrencyFormatter {
    /** Минорные единицы (копейки) → строка для инпута/подписи. */
    toShow: (value: number, hideCurrency?: boolean) => string;
    /** Значение из инпута (рубли) → минорные единицы для отправки на бэк. */
    toSend: (value: number) => number;
}

export const createCurrencyFormatter = (
    currency: CurrencyDto | null,
    locale: string
): CurrencyFormatter => {
    const decimalPlaces = currency ? currency.decimalPlaces : FALLBACK_DECIMAL_PLACES;
    const shortName = currency ? currency.shortName[locale] || "" : "";
    const factor = 10 ** decimalPlaces;

    return {
        toShow: (value: number, hideCurrency: boolean = false) => {
            const amount = (value / factor).toFixed(decimalPlaces);
            return hideCurrency || shortName === "" ? amount : `${amount} ${shortName}`;
        },
        toSend: (value: number) => parseInt((value * factor).toFixed(0)),
    };
};
